import Model from 'mewe/utils/store-utils/model/model';
import { attr, hasMany } from 'mewe/utils/store-utils/model/attribute';
import LevelModel from './quest-level-model';
import { computed } from '@ember/object';

const GamificationModel = Model.extend({
  levels: hasMany(LevelModel),
  isLoaded: attr('boolean', { defaultValue: false }), // loaded indicates if any data was loaded (false if no gamification data for this user)
  isFetching: attr('boolean', { defaultValue: true }), // fetching indicates pending request
  lastFetchedAt: attr('number', { defaultValue: 0 }), // lastFetchedAt indicates the last time the data was fetched

  currentLevel: computed('levels', 'levels.@each.completed', function() {
    if (!this.levels.length) return null; // no current level also indicates no gamification at all

    // find first not completed level or return null of all are completed
    return this.levels.find((level) => !level.completed) || null;
  }),

  previousLevel: computed('levels', 'currentLevel', function() {
    if (!this.levels.length) return null; // no levels indicates no gamification at all
    if (!this.currentLevel) return null; // no current level after completing all of them

    const currentLevelIndex = this.levels.indexOf(this.currentLevel);
    return this.levels[currentLevelIndex - 1] || null;
  }),

  nextLevel: computed('levels', 'currentLevel', function() {
    if (!this.levels.length) return null; // no levels indicates no gamification at all
    if (!this.currentLevel) return null; // no current level after completing all of them

    const currentLevelIndex = this.levels.indexOf(this.currentLevel);
    return this.levels[currentLevelIndex + 1] || null;
  }),

  isFinished: computed('isLoaded', 'currentLevel', function() {
    return this.isLoaded && !this.currentLevel;
  }),
});

export default GamificationModel;
